import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { arrayPrepend } from '../functions';


@Component({
  selector: 'app-sitemenu',
  templateUrl: './sitemenu.component.html',
  styleUrls: ['./sitemenu.component.css']
})


export class SitemenuComponent implements OnInit {
	menuItems = [
		// {
		// 	name: 'Logg inn',
		// 	slug: 'login',
		// 	id: 'login',
		// 	actions: [
		// 		{
		// 			name: 'Logg inn',
		// 			slug: 'login',
		// 			id: 'logginn',
		// 		},
		// 		{
		// 			name: 'Logg ut',
		// 			slug: 'logout',
		// 			id: 'logout',
		// 		},
		// 	]
		// },
		{
			name: 'Bedrifter',
			slug: 'clients',
			id: 'bedrifter',
			open: true,
			actions: [
				{
					name: 'Se alle bedrifter',
					slug: 'clients',
					id: 'bedrifter',
					params: ['all'],
				},
				{
					name: 'Se dine bedrifter',
					slug: 'clients',
					id: 'minebedrifter',
					params: ['mine'],
				},
				{
					name: 'Ny bedrift',
					slug: 'client',
					id: 'ny-bedrift',
					params: [0, 'create'],
				},
			],
		},
		// {
		// 	name: 'Prosjekter',
		// 	slug: 'projects',
		// 	id: 'prosjekter',
		// 	open: false,
		// 	actions: [
		// 		{
		// 			name: 'Se alle prosjekter',
		// 			slug: 'projects',
		// 			id: 'prosjekter',
		// 			params: ['all'],
		// 		},
		// 		{
		// 			name: 'Se dine prosjekter',
		// 			slug: 'projects',
		// 			id: 'mineprosjekter',
		// 			params: ['mine'],
		// 		},
		// 		{
		// 			name: 'Nytt Prosjekt',
		// 			slug: 'project',
		// 			id: 'nytt-prosjekt',
		// 			params: [0, 'create'],
		// 		},
		// 	],
		// },
		// {
		// 	name: 'Dokumenter',
		// 	slug: 'documents',
		// 	id: 'dokumenter',
		// 	open: false,
		// 	actions: [
		// 		{
		// 			name: 'Se alle dokumenter',
		// 			slug: 'documents',
		// 			id: 'http://localhost:8888/donna/backend/web/dokumenter',
		// 			params: ['all'],
		// 		},
		// 		{
		// 			name: 'Se dine dokumenter',
		// 			slug: 'documents',
		// 			id: 'minedokumenter',
		// 			params: ['mine'],
		// 		},
		// 		{
		// 			name: 'Nytt dokument',
		// 			slug: 'document',
		// 			id: 'nytt-dokument',
		// 			params: [0, 'create'],
		// 		}
		// 	],
		// },
		// {
		// 	name: 'Salg',
		// 	slug: 'sales',
		// 	id: 'salg',
		// 	open: false,
		// 	actions: [
		// 		{
		// 			name: 'Se alle salg',
		// 			slug: 'sales',
		// 			id: 'salg',
		// 			params: ['all'],
		// 		},
		// 		{
		// 			name: 'Se dine salg',
		// 			slug: 'sales',
		// 			id: 'minesalg',
		// 			params: ['mine'],
		// 		},
		// 		{
		// 			name: 'Nytt salg',
		// 			slug: 'sales', // what is sales in single (aka non-plural)?
		// 			id: 'nytt-salg',
		// 			params: [0, 'create'],
		// 		}
		// 	],
		// },
	];

	@Input() loggedIn: any = false;

	constructor (
		private router: Router,
	) { }

	/**
	 * open and close sub menus. remember open/closed menus in localStorage
	 * @param number. index. which menu item to change the status (open/closed) of. required.
	 * @param boolean. onInit. if triggered on component init, before any clicks have taken place, 
	 * set to true to load settings stored in localStorage (pass any number to index, the function won't use it anyway when onInit is true).
	 * optional. default: false.
	 */
	setSubMenuStatus ( index: number, onInit: boolean = false ) {

		if ( onInit == true ) {

			let menuSettings = JSON.parse(localStorage.getItem( 'donna-menu-settings'));

			// console.log(menuSettings);

			if ( menuSettings ) {

				for (var i = 0; i < menuSettings.length; ++i) {
					this.menuItems[i].open = menuSettings[i].open;
				}

			}

		} else {

			let menuItem = this.menuItems[index];

			if ( menuItem.open == true ) {
				menuItem.open = false;
			} else {
				menuItem.open = true;
			}

			localStorage.setItem( 'donna-menu-settings', JSON.stringify(this.menuItems) );

		}

	}

	goTo( url: any, params = [] ) {

		if ( params.length == 0 ) {
			this.router.navigate( [url] );
		} else {
			url = arrayPrepend( url, params );
			this.router.navigate( url );
		}
	}

	ngOnInit() {

		this.setSubMenuStatus(0, true);

	}

}


// WEBPACK FOOTER //
// ./src/app/sitemenu/sitemenu.component.ts